import React from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import logoRegistroPay from "../../../../styles/images/registro-pay/logo-registro-pay-branca.png";
import { BORDA, FONTE, FUNDO_CARTAO, FUNDO_REGISTRO_PAY, NAVY, SELO_REGISTRO_PAY, SUAVE, TEXTO_SOBRE_COR } from "../estilos/tokens";

export const LogoRegistroPay = ({ largura }: { largura: number }) => (
  <img src={logoRegistroPay} alt="Registro Pay" style={{ width: largura, maxWidth: "100%", height: "auto", display: "block" }} />
);

export const SeloEmBreve = ({ grande }: { grande?: boolean }) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      minWidth: grande ? 160 : 110,
      height: grande ? 38 : 28,
      padding: "0 16px",
      boxSizing: "border-box",
      borderRadius: grande ? 19 : 14,
      border: `1px solid ${TEXTO_SOBRE_COR}`,
      background: SELO_REGISTRO_PAY,
      color: TEXTO_SOBRE_COR,
      fontFamily: FONTE,
      fontSize: grande ? 16 : 12,
      fontWeight: 700,
      letterSpacing: 0.4,
    }}
  >
    EM BREVE
  </span>
);

const BENEFICIOS = [
  { titulo: "O que está bloqueado", descricao: "Saiba quais recebíveis estão vinculados a operações." },
  { titulo: "O que está liberado", descricao: "Veja os valores disponíveis para receber." },
  { titulo: "O que está previsto", descricao: "Acompanhe a previsão dos próximos recebimentos." },
];

const RegistroPay = () => {
  const telaPequena = useMediaQuery(useTheme().breakpoints.down("sm"));
  const quebra = telaPequena ? null : <br />;

  return (
    <div style={{ background: FUNDO_CARTAO, border: `1px solid ${BORDA}`, borderRadius: 18, padding: "clamp(16px, 4vw, 48px)" }}>
      <div
        style={{
          background: FUNDO_REGISTRO_PAY,
          borderRadius: 18,
          minHeight: 500,
          padding: "48px 24px",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          gap: 28,
        }}
      >
        <LogoRegistroPay largura={300} />
        <div style={{ fontFamily: FONTE, fontSize: "clamp(28px, 4vw, 54px)", lineHeight: 1.18, fontWeight: 700, color: TEXTO_SOBRE_COR }}>
          {"Quanto do seu futuro financeiro "}
          {quebra}
          já está comprometido?
        </div>
        <div style={{ fontFamily: FONTE, fontSize: "clamp(16px, 1.8vw, 24px)", lineHeight: 1.5, color: TEXTO_SOBRE_COR }}>
          {"Antecipações, garantias, cessões e previsão de recebimentos "}
          {quebra}
          em uma visão integrada.
        </div>
        <SeloEmBreve grande />
      </div>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "baseline",
          gap: 12,
          marginTop: 40,
        }}
      >
        <div style={{ fontFamily: FONTE, fontSize: 28, fontWeight: 700, color: NAVY }}>Mais clareza para o futuro do seu negócio.</div>
        <div style={{ fontFamily: FONTE, fontSize: 17, color: SUAVE }}>Uma nova experiência no Conciliador.</div>
      </div>

      <div style={{ display: "flex", flexDirection: telaPequena ? "column" : "row", marginTop: 32, gap: telaPequena ? 24 : 0 }}>
        {BENEFICIOS.map((beneficio, indice) => (
          <div
            key={beneficio.titulo}
            style={{
              flex: 1,
              minHeight: 86,
              padding: telaPequena ? 0 : `0 32px 0 ${indice === 0 ? 0 : 32}px`,
              paddingTop: telaPequena && indice > 0 ? 24 : undefined,
              borderLeft: telaPequena || indice === 0 ? "none" : `1px solid ${BORDA}`,
              borderTop: telaPequena && indice > 0 ? `1px solid ${BORDA}` : "none",
            }}
          >
            <div style={{ fontFamily: FONTE, fontSize: 22, fontWeight: 700, color: NAVY }}>{beneficio.titulo}</div>
            <div style={{ fontFamily: FONTE, fontSize: 18, lineHeight: "28px", color: SUAVE, marginTop: 8 }}>{beneficio.descricao}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RegistroPay;
